module.exports = __webpack_public_path__ + "img/quality_crew_7-7-2021.fcf70710.jpg";